import styles from "./WelcomeScreen.module.scss";
import dynamic from "next/dynamic";
import { useAuthSelector, useIsLoggedIn } from "@nf/common";
import { MDUp, XSSM } from "../../components";
import { DotsLoader } from "../../components/DotsLoader";
import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { LoginSplash } from "./components/LoginSplash/LoginSplash";
import {
  PAYMENT_PARAM,
  SUCCESS_VALUE,
} from "../../hooks/useCreatePaymentCallback";
import { googleAnalyticsEvent } from "lib/gtm";

const InitialWelcome = dynamic<any>(() =>
  import("screens/WelcomeScreen/components/InitialWelcome/InitialWelcome").then(
    (mod) => mod.InitialWelcome
  )
);
export const MOBILE_PARAM_SUBSCRIPTIONS = "subscriptions";
export const MOBILE_PARAM_SUBSCRIPTION_VALUE = "active";

export const WelcomeScreen = () => {
  const { query } = useRouter();
  const isLoggedIn = useIsLoggedIn();
  const { user, isCompleted } = useAuthSelector();

  const showViewForSubscribedAccount =
    query[MOBILE_PARAM_SUBSCRIPTIONS] === MOBILE_PARAM_SUBSCRIPTION_VALUE;
  const wasPaymentSuccessful = query[PAYMENT_PARAM] === SUCCESS_VALUE;

  useEffect(() => {
    if (user && isCompleted && wasPaymentSuccessful) {
      user.Email && googleAnalyticsEvent.subscriptionCompleted(user.Email);
    }
  }, [user, isCompleted, wasPaymentSuccessful]);

  return isLoggedIn ? (
    <section className={styles.welcomeContainer}>
      <XSSM>
        {showViewForSubscribedAccount ? <LoginSplash /> : <InitialWelcome />}
      </XSSM>
      <MDUp>
        <div className={styles.dotsContainer}>
          <DotsLoader />
        </div>
      </MDUp>
    </section>
  ) : null;
};
